import { Add, Delete, ForwardToInbox, GetApp, OpenInNew, PictureAsPdf } from '@mui/icons-material';
import {
  Box,
  Button,
  CardActions,
  CardContent,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { useDenuncias } from './hooks/useDenuncias';
import { isMobile } from '../../@iosper/utils/DeviceDetector';
import { useWidth } from '../../@iosper/utils/UseWidth';
import StyledDataGridSolicitudCobertura from '../Common/StyledDataGridSolicitudCobertura';
import { GridActionsCellItem } from '@mui/x-data-grid';
import { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { DatosDesplegableRow } from './components/DatosDesplegableRow';
import { AnularDenunciaModal } from './components/AnularDenunciaModal';
import CustomizedSnackbars from '../Notifications/SnackBar';
import { EnviarDenunciaModal } from './components/EnviarDenunciaModal';
import { EnviarProvidenciaDenunciaModal } from './components/EnviarProvidenciaDenunciaModal';

const limitText = (text = '', maxCharacters = 50) => {
  if (text.trim().length > maxCharacters) {
    return <>{text.trim().substring(0, maxCharacters - 3)}...</>;
  }

  return <>{text}</>;
};

export const ListDenuncia = () => {
  const { denuncias, getDenuncias, loading, getComprobanteDenuncia, getProvidenciaDenuncia } =
    useDenuncias();
  const [onOpenAnular, setOpenAnular] = useState(null);
  const [onOpenEnviar, setOpenEnviar] = useState(null);
  const [onOpenEnviarProvidencia, setOpenEnviarProvidencia] = useState(null);
  const [denuncia, setDenuncia] = useState(null);
  const [message, setMessage] = useState({ message: null, status: null });
  const history = useHistory();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('sm'));
  const esMobile = isMobile() || !matches;
  const screenWidth = useWidth();

  useEffect(() => {
    getDenuncias();
  }, []);

  const denunciaRow = (p, index) => {
    return {
      id: p.idSolicitudCobertura,
      correo: p.correo,
      idFormateado: p.idSolicitudCoberturaFormateado,
      afiliado: p.afiliado,
      afiliadonumerodocumento: p.afiliado + ' (' + p.numerodocumento + ')',
      tipoCobertura: p.tipoCobertura,
      estado: p.estado + ' (' + p.fechaestado + ')',
      observacion: p.observacion,
      fechaestado: p.fechaestado,
      idGrupoTipoCobertura: p.idGrupoTipoCobertura,
      codigoEstado: p.codigoEstado,
    };
  };

  const columns = [
    {
      field: 'desplegable',
      headerName: 'Reclamos',
      minHeight: 'unset',
      minWidth: 'unset',
      renderCell: (a) => (
        <DatosDesplegableRow
          denuncia={a.row}
          onAnular={(e) => {
            onHandleAnular(e);
          }}
          onHandlePreview={(e) => {
            onHandlePreview(e);
          }}
        />
      ),
    },
    { field: 'idFormateado', headerName: 'Nº', flex: 0.03 },
    { field: 'afiliadonumerodocumento', headerName: 'Afiliado', flex: 0.07 },
    { field: 'tipoCobertura', headerName: 'Tipo', flex: 0.1 },
    { field: 'estado', headerName: 'Estado', flex: 0.08 },
    {
      field: 'observacion',
      headerName: 'Motivo del reclamo',
      flex: 0.08,
      renderCell: ({ value }) => limitText(value),
    },
    {
      field: 'actions',
      headerName: 'Acciones',
      type: 'actions',
      width: 80,
      getActions: (params) => [
        <GridActionsCellItem
          icon={<PictureAsPdf />}
          title='Reporte PDF'
          label='Reporte PDF'
          showInMenu
          onClick={() => onHandleDescargar(params.row.afiliado, params.row.id)}
        />,
        <GridActionsCellItem
          icon={<OpenInNew />}
          title='Ver Solicitud'
          label='Ver Solicitud'
          showInMenu
          onClick={() => onHandlePreview(params.row)}
        />,
        <GridActionsCellItem
          icon={<Delete />}
          title='Anular Solicitud'
          label='Anular Solicitud'
          showInMenu
          disabled={params.row.codigoEstado !== '1'}
          onClick={() => {
            onHandleAnular(params.row);
          }}
        />,
        <GridActionsCellItem
          icon={<ForwardToInbox />}
          title='Enviar Solicitud'
          label='Enviar Solicitud'
          showInMenu
          disabled={params.row.codigoEstado !== '1' && params.row.codigoEstado !== '4'}
          onClick={() => onHandleEnviar(params.row)}
        />,
        <GridActionsCellItem
          icon={<GetApp />}
          title='Descargar Providencia'
          label='Descargar Providencia'
          showInMenu
          disabled={params.row.codigoEstado !== '3' && params.row.codigoEstado !== '4'}
          onClick={() => onHandlePreviewProvidencia(params.row)}
        />,
        <GridActionsCellItem
          icon={<ForwardToInbox />}
          title='Enviar Providencia'
          label='Enviar Providencia'
          showInMenu
          disabled={params.row.codigoEstado !== '3' && params.row.codigoEstado !== '4'}
          onClick={() => onHandleEnviarProvidencia(params.row)}
        />,
      ],
    },
  ];

  const tablaDenuncias = () => {
    if (!denuncias) return;

    const showHeader = {};
    if (screenWidth && screenWidth === 'xs') {
      showHeader['columnHeaderHeight'] = 0;
    }

    return (
      <Box style={{ margin: '0px 16px', height: '400px', width: 'auto' }}>
        <StyledDataGridSolicitudCobertura
          sx={{
            border: 0,
            '& .MuiDataGrid-cell': {
              py: '8px',
            },
          }}
          getRowClassName={(params) => `super-app-theme--${params.row.codigoEstado}`}
          columns={columns}
          rows={denuncias.map((a, index) => denunciaRow(a, index))} //
          getRowHeight={() => 'auto'}
          getEstimatedRowHeight={() => 200}
          slots={{
            NoRowsOverlay: () => (
              <Stack height='100%' alignItems='center' justifyContent='center'>
                Sin solicitudes de autorizaciones ambulantes.
              </Stack>
            ),
          }}
          columnVisibilityModel={{
            desplegable: screenWidth === 'xs',
            idFormateado: screenWidth !== 'xs',
            afiliadonumerodocumento: screenWidth !== 'xs',
            tipoCobertura: screenWidth !== 'xs',
            estado: screenWidth !== 'xs',
            observacion: screenWidth !== 'xs',
            actions: screenWidth !== 'xs',
          }}
          pagination
          autoPageSize
          disableColumnMenu
          {...showHeader}
          loading={loading}
        />
      </Box>
    );
  };

  const onHandleDescargar = async (filename, idSolicitud) => {
    try {
      const urlReporte = await getComprobanteDenuncia(idSolicitud);
      const link = document.createElement('a');
      link.style.display = 'none';
      link.setAttribute('href', urlReporte);
      link.setAttribute('download', 'Solicitud cobertura ' + filename + '.pdf');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      // handleClose();
    } catch (e) {
      console.log(e);
    }
  };

  const onHandlePreview = async (row) => {
    try {
      history.push('/reclamo/ver-reclamo', {
        from: history.location,
        denuncia: { ...row },
      });
    } catch (e) {
      console.log(e);
    }
  };

  const onHandlePreviewProvidencia = async (row) => {
    try {
      const pdf = await getProvidenciaDenuncia(row?.id);
      history.push({
        pathname: '/previsualizar',
        state: { url: pdf } || {}, // your data array of objects
      });
    } catch (e) {
      console.log(e);
    }
  };

  const onHandleAnular = async (row) => {
    setDenuncia(row);
    setOpenAnular(true);
  };

  const onHandleAnulada = async (anulada) => {
    setDenuncia(null);
    setOpenAnular(false);
    if (anulada) {
      getDenuncias();
    }
  };

  const onHandleEnviar = (row) => {
    setDenuncia(row);
    setOpenEnviar(true);
  };

  const onHandleEnviarProvidencia = (row) => {
    setDenuncia(row);
    setOpenEnviarProvidencia(true);
  };

  return (
    <>
      <CardContent>
        <Typography gutterBottom variant='h5' component='h2'>
          Reclamos
        </Typography>
        <Typography variant='body2' color='textSecondary' component='p' align='justify'>
          Aquí podés consultar el estado de los reclamos <b>realizadas en los últimos 30 días</b>.
          También podés informar situaciones como demoras o negativas en la atención, cobros
          indebidos, maltrato, irregularidades en las prestaciones o cualquier hecho que vulnere tus
          derechos como afiliado.
        </Typography>
      </CardContent>

      {tablaDenuncias()}

      <CardActions sx={{ justifyContent: 'flex-end', mx: 1, mt: 2 }}>
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            justifyContent: 'flex-end',
          }}
        >
          <Button
            component={Link}
            to={'/reclamo/nueva'}
            startIcon={<Add />}
            variant='contained'
            color='primary'
          >
            Nuevo Reclamo
          </Button>
        </Box>
      </CardActions>

      {onOpenAnular && denuncia ? (
        <AnularDenunciaModal
          open={onOpenAnular}
          denuncia={denuncia}
          setDenunciaAnulada={onHandleAnulada}
        />
      ) : null}

      {onOpenEnviar ? (
        <EnviarDenunciaModal
          open={onOpenEnviar}
          autorizacion={denuncia}
          setAutorizacion={() => {
            setMessage({
              message: 'La solicitud de reclamo ha sido enviada correctamente.',
              status: 'success',
            });
            setDenuncia(null);
            setOpenEnviar(false);
          }}
          onCancelar={() => setOpenEnviar(false)}
        />
      ) : null}

      {onOpenEnviarProvidencia ? (
        <EnviarProvidenciaDenunciaModal
          open={onOpenEnviarProvidencia}
          autorizacion={denuncia}
          setAutorizacion={() => {
            setMessage({
              message: 'La solicitud de reclamo ha sido enviada correctamente.',
              status: 'success',
            });
            setDenuncia(null);
            setOpenEnviarProvidencia(false);
          }}
          onCancelar={() => setOpenEnviarProvidencia(false)}
        />
      ) : null}

      {message?.message && message?.message !== '' && (
        <CustomizedSnackbars
          open={message?.message && message?.message !== ''}
          autoHideDuration={8000}
          severity={message?.status || 'success'}
          message={message?.message || ''}
        />
      )}
    </>
  );
};
